import { createStore } from "redux";
import { logReducer } from "./reducers/logReducer";

const store = createStore(logReducer);

export default store;